import { DateSchema, StringSchema, array, date, object, string } from "yup"
import { OptionalArraySchema } from "yup/lib/array"
import { t } from "i18next"

/**
 * getDynamicFieldSchema
 * ------------------------------------------------
 * DESCRIPTION_HERE
 */

interface DynamicFieldSchemaArgs {
  fieldName: string
  fieldType?: "array" | "string" | "date"
  isOptional: boolean
  messages: {
    required: string
    validation: string
  }
  mustMatchFieldName?: string | null
  // should represent potentially all yup string methods, currently the only used method is e-mail
  method?: string | null
  pattern?: string | null
  minimum_multiselect_selections: number | 1
  values?: { [key: string]: any }
}

export const getDynamicFieldSchema = ({
  fieldName,
  fieldType = "string",
  isOptional,
  method,
  pattern,
  messages,
  values,
  mustMatchFieldName,
  minimum_multiselect_selections,
}: DynamicFieldSchemaArgs) => {
  let arraySchema: OptionalArraySchema<any> = array()
  let stringSchema: StringSchema = string()
  let dateSchema: DateSchema = date().default(undefined)

  // it needs to know if a field is optional
  if (!isOptional) {
    if (fieldType === "array") {
      arraySchema = arraySchema
        .required(messages.required)
        .min(minimum_multiselect_selections, messages.required)
    } else {
      stringSchema = stringSchema.required(messages.required)
      dateSchema = dateSchema
        .required(messages.required)
        .typeError(messages.required)
    }
  }

  // it needs to know what yup methods to use (i.e. e-mail)
  if (method && method === "email") {
    if (mustMatchFieldName && !mustMatchFieldName.match(/confirm/)) {
      stringSchema = stringSchema
        .email(t("client.validation.email"))
        .matches(values?.[mustMatchFieldName], messages.validation)
    }
    stringSchema = stringSchema.email(messages.validation)
  }

  // it should assess regex patterns if the data has a pattern
  if (pattern && method !== "age") {
    const regex = new RegExp(pattern)
    stringSchema = stringSchema.matches(regex, messages.validation)
  } else if (pattern && method === "age") {
    const minAge = new Date(
      new Date().setFullYear(new Date().getFullYear() - Number(pattern)),
    )
    dateSchema = dateSchema.max(minAge, messages.validation)
  }

  // it needs to return a yup schema object
  return object({
    [fieldName]:
      fieldType === "array"
        ? arraySchema
        : fieldType === "date"
        ? dateSchema
        : stringSchema,
  })
}
